import React from 'react';
import { CTAButton } from './CTAButton';
export function HookSection() {
  return <section id="hook-section" className="w-full py-20 px-4 border-t" style={{
    backgroundColor: '#0f172a',
    borderColor: '#334155'
  }} data-id="element-193">
      <div className="max-w-3xl mx-auto" data-id="element-194">
        <p className="text-lg mb-6 font-bold" style={{
        color: '#f1f5f9'
      }} data-id="element-195">
          Primero, necesito decirte algo importante.
        </p>

        <p className="text-lg mb-4" style={{
        color: '#94a3b8'
      }} data-id="element-196">
          No voy a usar palabras complicadas en esta página.
        </p>
        <p className="text-lg mb-4" style={{
        color: '#94a3b8'
      }} data-id="element-197">
          Sin "embudos", sin "conversión", sin "SEO".
        </p>
        <p className="text-lg mb-8" style={{
        color: '#94a3b8'
      }} data-id="element-198">
          Solo te voy a explicar, de la manera más sencilla posible, cómo
          personas normales — personas exactamente como tú, que nunca han ganado
          un dólar por internet — están construyendo un ingreso real de{' '}
          <strong style={{
          color: '#f59e0b'
        }} data-id="element-199">
            2 a 6 millones de pesos al mes
          </strong>{' '}
          en 2026.
        </p>

        <div className="space-y-2 mb-8" data-id="element-200">
          <p className="text-lg" style={{
          color: '#f1f5f9'
        }} data-id="element-201">
            Desde casa.
          </p>
          <p className="text-lg" style={{
          color: '#f1f5f9'
        }} data-id="element-202">
            Sin jefe.
          </p>
          <p className="text-lg" style={{
          color: '#f1f5f9'
        }} data-id="element-203">
            Sin horario fijo.
          </p>
          <p className="text-lg" style={{
          color: '#f1f5f9'
        }} data-id="element-204">
            Sin saber nada de tecnología, diseño o marketing.
          </p>
        </div>

        <p className="text-xl font-bold mb-6" style={{
        color: '#f59e0b'
      }} data-id="element-205">
          ¿Cómo?
        </p>

        <div className="space-y-4 mb-8" style={{
        color: '#94a3b8'
      }} data-id="element-206">
          <p className="text-lg" data-id="element-207">
            Creando páginas web sencillas — llamadas "landing pages" — para
            pequeños negocios en Colombia.
          </p>
          <p className="text-lg" data-id="element-208">
            Usando herramientas de Inteligencia Artificial que hacen el 80% del
            trabajo por ti.
          </p>
          <p className="text-lg" data-id="element-209">En menos de 1 hora por página.</p>
          <p className="text-lg" data-id="element-210">
            Y cobrando entre{' '}
            <strong style={{
            color: '#f1f5f9'
          }} data-id="element-211">
              $200.000 y $800.000 pesos
            </strong>{' '}
            por cada una.
          </p>
        </div>

        <p className="text-lg mb-4" style={{
        color: '#94a3b8'
      }} data-id="element-212">
          No es una promesa vacía.
        </p>
        <p className="text-lg mb-12" style={{
        color: '#f1f5f9'
      }} data-id="element-213">
          Es exactamente lo que el{' '}
          <strong style={{
          color: '#f59e0b'
        }} data-id="element-214">
            Sistema LPM™
          </strong>{' '}
          hace posible.
        </p>

        <CTAButton text="SÍ — QUIERO VER CÓMO FUNCIONA EL SISTEMA LPM™ POR SOLO $49.999" subtitle="✅ Guía PDF paso a paso · ✅ Descarga inmediata · ✅ Garantía de 30 días" scrollTo="pain-section" data-id="element-215" />
      </div>
    </section>;
}